module.exports = __webpack_public_path__ + "img/Gossypium_barbadense.2563d03c.jpg";